import { useQuery } from "@tanstack/react-query";
import { getOffers } from "../services/offers";

export function useOffers(options = {}) {

    const outletUid = localStorage.getItem(

        "selectedOutletUid"

    );

    return useQuery({

        queryKey: [

            "offers",

            outletUid,

        ],

        queryFn: () =>

            getOffers(

                outletUid

            ),

        enabled: !!outletUid,

        staleTime: 1000 * 60 * 5,

        ...options,

    });

}